import { render, staticRenderFns } from "./InstallDialog.vue?vue&type=template&id=e54a2b7c&scoped=true&"
import script from "./InstallDialog.vue?vue&type=script&lang=js&"
export * from "./InstallDialog.vue?vue&type=script&lang=js&"
import style0 from "./InstallDialog.vue?vue&type=style&index=0&id=e54a2b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54a2b7c",
  null
  
)

component.options.__file = "InstallDialog.vue"
export default component.exports